export default function() {
  return {
    restrict: 'A',
    require: 'ngModel',
    scope: {
      model: '=ngModel'
    },
    link: function(scope, element, attrs, ngModel) {
      scope.$watch('model', function(newModel) {
        if (newModel < 0) {
          ngModel.$setViewValue('45');
        }

        if (newModel === 0 || newModel === 60) {
          ngModel.$setViewValue('00');
        }

        if (newModel > 60) {
          const truncated = Number(newModel.toString().slice(0, 2));
          ngModel.$setViewValue(truncated > 59 ? '00' : truncated);
        }

        attrs.$set('step', newModel % 15 === 0 ? 15 : 1);

        ngModel.$render();
      });
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/directives/minuteFormat/index.js